(() => {
  angular
    .module('gm.common.services')
    .factory('gmAurumStats', gmAurumStatsFactory);

  function gmAurumStatsFactory(
    gmApi,
    promiseCache
  ) {
    'ngInject';

    return {
      getAccounts,
      getAssets,
      getStats,
      getVolume,
    };

    function getAccounts() {
      return getStats()
        .then(stats => stats.Accounts);
    }

    function getAssets() {
      return getStats()
        .then(stats => stats.Assets);
    }

    function getStats() {
      return promiseCache({
        promise: () => gmApi.get('aurum/globalStats'),
        ttl: 1000
      });
    }

    function getVolume() {
      return getStats()
        .then(stats => stats.Volume);
    }
  }
})();
